import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core';
import srcImage from "images/prop@2x.png";
import Button from "storybookComponents/Button"
export const styles = () => ({
  root: {
    height: 'inherit',
    display: 'flex',
    flexFlow: 'column',
  },
  emptyBox: {
    background: '#FFFFFF',
    border: '1px solid #DADADA',
    boxSizing: 'border-box',
    flex: '1 1 auto',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  NPText: {
    marginTop: 8,
    textAlign: 'center',
    fontSize: 16,
    lineHeight: '24px',
    color: 'rgba(51, 51, 51, 0.75)',
    marginBottom: 32
  },
  btnClass: {
    width: 168,
    height: 40,
    fontSize: 14,
    textTransform: "none",
    fontWeight: 600,
    padding: "10px 16px",
    lineHeight: "20px"
  }
})

const NoPropView = ({ classes, message, image, handleButtonClick, showButton }) => {
  return (
    <Box className={classes.root}>
      <Box className={classes.emptyBox}>
        <img src={image || srcImage} alt="No Properties" />
        <Typography className={classes.NPText}>
          {message}
        </Typography>
        {
          showButton ? <Button variant="md" className={classes.btnClass} onClick={handleButtonClick}>
            + Referral Campaign
          </Button> : ""
        }
      </Box>
    </Box>
  )
}

export default withStyles(styles)(NoPropView)